import { useTranslation } from '@pasteltech/react-i18n'
import { FontWeight } from '@pasteltech/theme-provider'
import { Link } from 'gatsby'
import { memo } from 'react'
import styled from 'styled-components'
import { ArrowForwardIcon } from '../../svg-components'

const StyledButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;
  padding: ${({ theme }) =>
    `${theme.sizes.spacings.lg}px ${theme.sizes.spacings.xxl}px`};
  gap: ${({ theme }) => theme.sizes.spacings.xs}px;
  border-radius: ${({ theme }) => theme.sizes.borderRadius.xs}px;
  border: 1px solid ${({ theme }) => theme.colors.container.lowest};
  color: ${({ theme }) => theme.colors.container.lowest};
  path {
    stroke: ${({ theme }) => theme.colors.container.lowest};
    fill: ${({ theme }) => theme.colors.container.lowest};
  }
  &:hover {
    cursor: pointer;
    background: rgba(255, 255, 255, 0.2);
    path {
      stroke: ${({ theme }) => theme.colors.container.lowest};
      fill: ${({ theme }) => theme.colors.container.lowest};
    }
  }
  &:active {
    background: ${({ theme }) => theme.colors.container.lowest};
    color: ${({ theme }) => theme.colors.container.high};
    path {
      stroke: ${({ theme }) => theme.colors.container.high};
      fill: ${({ theme }) => theme.colors.container.high};
    }
  }
`
const ButtonText = styled.div`
  font-size: ${({ theme }) => theme.sizes.fontSize.button}px;
  font-weight: ${FontWeight.bold};
`
const StyledLink = styled(Link)`
  text-decoration: none;
`
type Props = {
  to: string
}
export const CheckMoreButton = memo(({ to }: Props) => {
  const { t } = useTranslation()
  return (
    <StyledLink to={to}>
      <StyledButton>
        <ButtonText>{t('button.checkMore')}</ButtonText>
        <ArrowForwardIcon />
      </StyledButton>
    </StyledLink>
  )
})

CheckMoreButton.displayName = 'CheckMoreButton'
